<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import purchaseApi from "@/api/purchase";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["customerPurchaseOrder"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      purchaseGoods: [],
      dataList: [],
      columns: [
        {
          type: "expand",
          render: (h, params) => {
            const row = params.row;
            const shipmentModeMap = {
              1: "空运",
              2: "海运",
              3: "陆运",
            };
            return (
              <div style={{ width: "1000px", paddingLeft: "50px" }}>
                <el-descriptions title="发货信息" column={4} border>
                  <el-descriptions-item label="发货时间">
                    {row.shipmentDate}
                  </el-descriptions-item>
                  <el-descriptions-item label="到货时间">
                    {row.arrivalDate}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货方式">
                    {shipmentModeMap[row.shipmentMode]}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货地区">
                    {row.shippedFrom}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货人">
                    {row.shipperName}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货人电话">
                    {row.shipperPhone}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货人邮箱">
                    {row.shipperEmail}
                  </el-descriptions-item>
                </el-descriptions>
                <el-descriptions title="清关信息" border>
                  <el-descriptions-item label="转出关区">
                    {row.outAreaName}
                  </el-descriptions-item>
                  <el-descriptions-item label="转出关区代码">
                    {row.outAreaCode}
                  </el-descriptions-item>
                  <el-descriptions-item label="提单号">
                    {row.landingBillNo}
                  </el-descriptions-item>
                  <el-descriptions-item label="报关信息">
                    {row.declareDetailList
                      ? JSON.parse(row.declareDetailList).map((item) => (
                          <a
                            style={{ color: "blue" }}
                            href={item.url}
                            key={item.url}
                          >
                            {item.url}
                          </a>
                        ))
                      : ""}
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            );
          },
        },
        {
          title: "来源单号",
          key: "originOrderNo",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={this.jumpToDetailPage.bind(this, row)}
              >
                {row.originOrderNo}
              </a>
            );
          },
        },
        {
          title: "入库类型",
          key: "inboundType",
          width: 150,
          align: "center",
        },
        {
          title: "仓库id",
          key: "warehouseId",
          width: 200,
          align: "center",
        },
        {
          title: "申报状态",
          width: 200,
          key: "status",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              WAIT_DECLARE: ["info", "待申报"],
              PART_DECLARE: ["warning", "部分申报"],
              DECLARE_SUCCESS: ["success", "全部申报"],
            };
            return (
              <div>
                <el-tag type={tagType[row.status][0]}>
                  {tagType[row.status][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "推送wms状态",
          width: 200,
          key: "wmsStatus",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待推送"],
              WMS_CREATE_SUCCESS: ["success", "推送仓库成功"],
              ARRIVE_TO_WMS: ["success", "货物到仓"],
              START_TALLY: ["success", "开始理货"],
              TALLY_FINISHED: ["success", "理货完成"],
              WMS_CREATE_EXCEPTION: ["error", "推送仓库异常"],
              WMS_STOCKIN_FINISHED: ["success", "入库完成"],
              CANCELED: ["info", "已取消"],
            };
            return (
              <div>
                <el-tag type={tagType[row.wmsStatus][0]}>
                  {tagType[row.wmsStatus][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreate",
          align: "center",
        },
      ],
      customsDeclareStatus: {
        INIT: "初始化",
        PLATFORM_AUDITING: "待口岸审核",
        PLATFORM_AUDIT_REJECT: "口岸驳回",
        CUSTOMS_AUDITING: "待总署审核",
        CUSTOMS_AUDIT_PASS: "总署审核通过",
        CUSTOMS_AUDIT_REJECT: "总署驳回",
      },
      filterObj: {
        originOrderNo: "",
        warehouseId: "",
        customerId: "",
        status: "",
        wmsStatus: "",
      },
      currentRow: [],
    };
  },
  methods: {
    jumpToDetailPage(row) {
      this.$router.push({
        name: "purchaseOrderDetail",
        params: { purchaseId: row.id },
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        let start = filterParams.applyTime[0] + " 00:00:00",
          end = filterParams.applyTime[1] + " 23:59:59";
        filterParams.gmtCreateStart = new Date(start).getTime();
        filterParams.gmtCreateEnd = new Date(end).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      let searchCondition = {
        ...filterParams,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      purchaseApi.list({ request: searchCondition }).then((res) => {
        this.dataList = res.items;
        this.pagination.currentPage = res.page.pageIndex;
        this.pagination.pageSize = res.page.pageSize;
        this.pagination.totalCount = res.page.totalCount;
        this.loading = false;
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "来源单号",
              model: "originOrderNo",
              type: type.INPUT,
            },
            {
              label: "申报状态",
              model: "status",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "WAIT_DECLARE",
                    label: "待申报",
                  },
                  {
                    value: "PART_DECLARE",
                    label: "部分申报",
                  },
                  {
                    value: "DECLARE_SUCCESS",
                    label: "全部申报",
                  },
                ],
              },
            },
            {
              label: "wms推送状态",
              model: "wmsStatus",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "INIT",
                    label: "待推送wms",
                  },
                  {
                    value: "WMS_CREATE_SUCCESS",
                    label: "推送wms成功",
                  },
                  {
                    value: "WMS_CREATE_EXCEPTION",
                    label: "推送wms异常",
                  },
                  {
                    value: "WMS_STOCKIN_FINISHED",
                    label: "入库完成",
                  },
                ],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
